import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import CheapWebDevelopment from "@/pages/CheapWebDevelopment";
import CityWebDesign from "@/pages/CityWebDesign";
import IndustryWebDesign from "@/pages/IndustryWebDesign";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <main
    data-testid="not-found-page"
    className="pt-40 min-h-[80vh] mx-auto max-w-[1400px] px-6 lg:px-10"
  >
    <h1 className="text-6xl font-black tracking-tighter font-[Cabinet_Grotesk]">
      404
    </h1>
    <p className="mt-4 text-[#525252]">This page doesn&apos;t exist yet.</p>
    <a
      href="/"
      className="mt-8 inline-flex items-center gap-2 text-xs tracking-widest uppercase font-bold text-[#3A00FF]"
    >
      ← Back home
    </a>
  </main>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] antialiased">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/affordable-website-development"
              element={<CheapWebDevelopment />}
            />
            <Route
              path="/website-development-for-companies"
              element={<CheapWebDevelopment />}
            />
            <Route
              path="/guenstige-website-entwicklung"
              element={<CheapWebDevelopment />}
            />
            <Route
              path="/website-development/:city"
              element={<CityWebDesign />}
            />
            <Route
              path="/website-development-for/:industry"
              element={<IndustryWebDesign />}
            />
            <Route path="/impressum" element={<Legal page="impressum" />} />
            <Route path="/imprint" element={<Legal page="impressum" />} />
            <Route path="/datenschutz" element={<Legal page="datenschutz" />} />
            <Route path="/privacy" element={<Legal page="datenschutz" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <Toaster
            position="top-right"
            toastOptions={{
              className:
                "rounded-none border border-[#0A0A0A] bg-white text-[#0A0A0A] font-[Satoshi]",
            }}
          />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
